import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetInternalRetailSubDealersQuery } from '../../../../api/endpoints/parts';
import { useLanguage } from '../../../../contexts/LanguageContext';

/**
 * İç transfer bayileri için sunucu taraflı aranabilir dropdown.
 * Kullanıcı yazdıkça `SearchText` ile BE'ye istek atılır (get-sub-dealers).
 *
 * @param {Object} props
 * @param {string|number|null} props.value - Seçili değer
 * @param {Function} props.onChange - Seçim değiştiğinde çağrılır (yeni value)
 * @param {Array} [props.extraOptions] - Listenin başına eklenecek ekstra seçenekler (ör. "Tümü")
 * @param {boolean} [props.showClear] - Temizle butonu göster
 * @param {string} [props.className]
 * @param {string} [props.placeholder]
 * @param {number} [props.rowCount] - BE'den çekilecek maksimum kayıt
 */
const InternalRetailSubDealerDropdown = ({
    value,
    onChange,
    extraOptions = [],
    showClear = false,
    className = 'w-full',
    placeholder,
    rowCount = 50
}) => {
    const { th } = useLanguage();
    const [searchText, setSearchText] = useState('');
    const [selectedOption, setSelectedOption] = useState(null);
    const [dropdownKey, setDropdownKey] = useState(0);

    const { data: subDealers = [], isFetching } = useGetInternalRetailSubDealersQuery({
        SearchText: searchText.trim(),
        RowCount: rowCount
    });

    let options = [...extraOptions, ...subDealers];
    // Seçili değer, arama sonucundaki listede yoksa görünür kalması için başa eklenir
    if (selectedOption && !options.some((o) => o.value === selectedOption.value)) {
        options = [selectedOption, ...options];
    }

    const handleChange = (e) => {
        const opt = options.find((o) => o.value === e.value) || null;
        setSelectedOption(opt);
        onChange(e.value);
    };

    // Dropdown kapanınca aramayı sıfırla ve temiz durumla yeniden render et
    const handleHide = () => {
        setSearchText('');
        setDropdownKey((k) => k + 1);
    };

    return (
        <Dropdown
            key={dropdownKey}
            value={value}
            options={options}
            onChange={handleChange}
            onFilter={(e) => setSearchText(e.filter)}
            onHide={handleHide}
            optionLabel="label"
            optionValue="value"
            filter
            filterBy="label"
            showClear={showClear}
            placeholder={placeholder || th('internalRetailParts.selectDealer') || 'Bayi seçiniz'}
            loading={isFetching}
            className={className}
            emptyFilterMessage={th('filter.noResultsFound') || 'Sonuç bulunamadı'}
        />
    );
};

export default InternalRetailSubDealerDropdown;
